module.exports = __webpack_public_path__ + "img/mobile_index_banner_5.fdccbf69.jpg";